import { render, staticRenderFns } from "./myHeader.vue?vue&type=template&id=cb6fca4e&"
import script from "./myHeader.vue?vue&type=script&lang=js&"
export * from "./myHeader.vue?vue&type=script&lang=js&"
import style0 from "./myHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports